export interface ShareRequest {
  bloodType: string
  patientName: string
  hospital: string
  city: string
  state: string
  urgency: string
  shareToken: string
}

export function generateWhatsAppMessage(req: ShareRequest): string {
  const urgencyEmoji = req.urgency === 'critical' ? '🚨' : req.urgency === 'high' ? '⚠️' : '🩸'
  const baseUrl = window.location.origin
  
  return `${urgencyEmoji} *DOAÇÃO DE SANGUE URGENTE* ${urgencyEmoji}

💉 Tipo Sanguíneo: *${req.bloodType}*
👤 Paciente: ${req.patientName}
🏥 Hospital: ${req.hospital}
📍 Local: ${req.city}/${req.state}

🙏 Você pode salvar uma vida!
Compartilhe com amigos e familiares.

👉 Mais informações: ${baseUrl}/solicitacao/${req.shareToken}

#DoeSangue #SalveVidas #Doe`
}

export function generateFacebookMessage(req: ShareRequest): string {
  const urgencyText = req.urgency === 'critical' ? 'URGENTE' : req.urgency === 'high' ? 'IMPORTANTE' : 'Pedido de Ajuda'
  const baseUrl = window.location.origin
  
  return `🩸 ${urgencyText}: Doação de Sangue Tipo ${req.bloodType}

Paciente ${req.patientName} precisa de doação de sangue no ${req.hospital}, em ${req.city}/${req.state}.

Você pode fazer a diferença! Se você ou alguém que conhece tem sangue tipo ${req.bloodType}, por favor considere doar.

Mais informações: ${baseUrl}/solicitacao/${req.shareToken}

Compartilhe para ajudar! 🙏
#DoeSangue #SalveVidas #${req.city}`
}

export function generateInstagramMessage(req: ShareRequest): string {
  const urgencyEmoji = req.urgency === 'critical' ? '🚨🚨🚨' : '🩸'
  const baseUrl = window.location.origin
  
  return `${urgencyEmoji} DOAÇÃO DE SANGUE

Tipo: ${req.bloodType}
Local: ${req.city}/${req.state}
Hospital: ${req.hospital}

Você pode salvar uma vida hoje! 🙏

Link: ${baseUrl}/solicitacao/${req.shareToken}

#DoeSangue #SalveVidas #${req.city} #${req.state} #DoadorDeSangue #Solidariedade #AmorAoProximo`
}

export function generateTwitterMessage(req: ShareRequest): string {
  const urgencyEmoji = req.urgency === 'critical' ? '🚨' : '🩸'
  const baseUrl = window.location.origin
  
  return `${urgencyEmoji} URGENTE: Doação ${req.bloodType} em ${req.city}/${req.state}

${req.hospital} precisa de ajuda AGORA!

Você pode salvar uma vida 🙏

${baseUrl}/solicitacao/${req.shareToken}

#DoeSangue #${req.city}`
}

export function generateLinkedInMessage(req: ShareRequest): string {
  const baseUrl = window.location.origin
  
  return `🩸 Pedido de Doação de Sangue - Sua Rede Pode Salvar uma Vida

Estou compartilhando um pedido urgente de doação de sangue:

📍 Local: ${req.hospital} - ${req.city}/${req.state}
💉 Tipo Sanguíneo: ${req.bloodType}
👤 Paciente: ${req.patientName}
⚠️ Urgência: ${req.urgency === 'critical' ? 'Crítica' : req.urgency === 'high' ? 'Alta' : 'Normal'}

Se você ou alguém da sua rede pode ajudar, por favor acesse:
${baseUrl}/solicitacao/${req.shareToken}

Compartilhar este post pode fazer a diferença entre a vida e a morte. A solidariedade começa com um gesto simples.

#DoaçãoDeSangue #Solidariedade #SalveVidas #ResponsabilidadeSocial`
}

export function generateEmailSubject(req: ShareRequest): string {
  return `🩸 Urgente: Doação de sangue tipo ${req.bloodType} necessária em ${req.city}/${req.state}`
}

export function generateEmailBody(req: ShareRequest): string {
  const baseUrl = window.location.origin
  
  return `Olá,

Preciso da sua ajuda para divulgar um pedido urgente de doação de sangue:

INFORMAÇÕES:
• Tipo Sanguíneo: ${req.bloodType}
• Paciente: ${req.patientName}
• Hospital: ${req.hospital}
• Cidade: ${req.city}/${req.state}
• Urgência: ${req.urgency === 'critical' ? 'Crítica' : req.urgency === 'high' ? 'Alta' : 'Normal'}

Se você ou alguém que conhece pode doar, por favor acesse:
${baseUrl}/solicitacao/${req.shareToken}

Compartilhe este pedido com seus contatos. Você pode salvar uma vida!

Obrigado,
Plataforma Doe`
}
